import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LegalNoticeComponent } from './legal-notice/legal-notice.component';
import { SharedModule } from '@ot/ifta/features/shared';

@NgModule({
  declarations: [LegalNoticeComponent],
  imports: [CommonModule, SharedModule]
})
export class SharedLegalNoticeModule {}
